import { observer } from 'mobx-react';
import React from 'react';

import PatientLogout from 'src/components/pages/pageElements/patientDebug/PatientLogout';
import SmsMessages from 'src/components/pages/pageElements/patientDebug/SmsMessages';
import WebMessenger from 'src/components/pages/pageElements/patientDebug/WebMessenger';
import PatientTasks from 'src/components/pages/pageElements/tasks/PatientTasks';
import { EDIT_DOSE_SPOT_MEDS_ON_DEBUG_PAGE } from 'src/featureFlags/currentFlags';
import { useFeatureFlag } from 'src/featureFlags/useFeatureFlag';
import { PageTitle } from 'src/nightingale/components/common/PageTitle/PageTitle';
import { ReadOnlyOverrideProvider } from 'src/nightingale/contextProviders/readOnlyOverride';
import PatientOverview from 'src/nightingale/pages/PatientOverview';

const PatientDebug = ({ data, patientId }) => {
  const editDoseSpotMedsOnDebugPageEnabled = useFeatureFlag(EDIT_DOSE_SPOT_MEDS_ON_DEBUG_PAGE);
  return (
    <>
      <PageTitle>Patient Debug</PageTitle>
      {/* Error Links */}
      <div>
        <a href={data?.errorLink}>{data?.errorLink}</a>
      </div>
      {/* Logout Patient Button */}
      <PatientLogout patientId={patientId} />
      {/* Task Creator */}
      <PatientTasks patientId={patientId} />
      {/* SMS Messages */}
      <SmsMessages patientId={patientId} />
      {/* Web Messenger */}
      <WebMessenger patientId={patientId} />
      {/*
       * Hack to allow editing of doseSpotMedicationsV2 chart property (which is normally readonly).
       * This loads the entire overview with readonly protections disabled, but it populates a
       * search phrase so that only the DoseSpot medications element is displayed.
       *
       * Feature flag is basically permanent -- we generally want to disallow this editing in prod
       * and allow it in QA. But we might want to turn it on in prod here or there.
       */}
      {editDoseSpotMedsOnDebugPageEnabled ? (
        <>
          <PageTitle>Edit DoseSpot Medications</PageTitle>
          <ReadOnlyOverrideProvider>
            <PatientOverview
              patientId={patientId}
              // This search phrase is brittle -- if the label of the chart element is edited, this may
              // no longer find it.
              initialSearch="dosespot active medications"
              showSearch={false}
            />
          </ReadOnlyOverrideProvider>
        </>
      ) : null}
    </>
  );
};

export default observer(PatientDebug);
